import { CarouselTrackingData } from "./CarouselTrackingData";

export default abstract class RecoTracking {
  abstract trackRecoImpression(data: CarouselTrackingData): void;

  abstract trackRecoClick(data: CarouselTrackingData, position?: string): void;
}
